import React, { PropTypes, Component } from 'react';

class ExtrusionSettings extends Component {
  static propTypes = {
    enabled: PropTypes.bool,
    submit: PropTypes.func.isRequired,
    change: PropTypes.func,
    steps: PropTypes.object
  };

  static defaultProps = {
    change: function() {}
  }

  change(e) {
    var height = e.target.value;
    this.props.change(height);
  }

  submit(e) {
    e.preventDefault();
    this.props.submit();
  }

  render() {
    return (
      <div className="ExtrusionSettings">
        <form className="form" onSubmit={this.submit.bind(this)} encType="multipart/form-data">
          <div className="form-group col-md-6 no-padding small-right">
            <input className="form-control" onChange={this.change.bind(this)} value={this.props.steps.height} type="text" name="height" />
          </div>

          <div className="form-group col-md-6 no-padding small-left">
            <input className="btn btn-primary btn-block" disabled={(this.props.enabled) ? false : 'disabled'} type="submit" value="Convert" />
          </div>

          <div className="col-md-12 no-padding">
            <p className="help-block">Choose an extrusion height greater than 0 and less than or equal to 300mm</p>
          </div>

        </form>
      </div>
    );
  }
}

export default ExtrusionSettings;



/** WEBPACK FOOTER **
 ** ./src/components/ExtrusionSettings/ExtrusionSettings.js
 **/